import Repository from './Repository';

const resource = '/responsabilidades';

function getParametros(ids) {
  const parametros = ids.map((id) => `responsabilidade=${id}`);
  return parametros.join('&');
}

export default {
  getAllByMapeamento(mapeamento, comissao) {
    return Repository.get(`${resource}/?mapeamento=${mapeamento}&comissao=${comissao}`);
  },

  getByDiagnostico(diagnostico) {
    return Repository.get(`${resource}/diagnostico/${diagnostico}`);
  },

  getByDiagnosticoAndUnidades(diagnostico, unidades) {
    return Repository.post(`${resource}/diagnostico/${diagnostico}/unidades`, unidades);
  },

  create(mapeamento, payload) {
    return Repository.post(`${resource}/?mapeamento=${mapeamento}`, payload);
  },

  update(origem, id, payload) {
    return Repository.put(`${resource}/${id}?origem=${origem}`, payload);
  },

  validar(ids) {
    const parametros = getParametros(ids);
    return Repository.put(`${resource}/validar?${parametros}`);
  },

  desvalidar(id) {
    return Repository.put(`${resource}/desvalidar/${id}`);
  },

  normalizar(ids) {
    const parametros = getParametros(ids);
    return Repository.put(`${resource}/normalizar?${parametros}`);
  },

  desnormalizar(id) {
    return Repository.put(`${resource}/desnormalizar/${id}`);
  },

  consolidar(ids) {
    const parametros = getParametros(ids);
    return Repository.put(`${resource}/consolidar?${parametros}`);
  },

  desconsolidar(id) {
    return Repository.put(`${resource}/desconsolidar/${id}`);
  },

  setExcluida(id) {
    return Repository.put(`${resource}/excluir/${id}`);
  },

  restaurar(id) {
    return Repository.put(`${resource}/restaurar/${id}`);
  },

  delete(id) {
    return Repository.delete(`${resource}/${id}`);
  },
};
